//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'page-chargeback-view',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    workOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      saving: false,
      operationLogInputDto: {},
      rules: {
        dealWithRemark: [{required: true, message: "请填写退单原因", trigger: 'blur'}]
      }
    };
  },
  methods: {
    visibleChange(value) {
      if (!value) {
        this.$emit('input', value);
      }
    },
    cancel() {
      this.$refs.form.resetFields();
      this.$emit('input', false);
    },
    onSaveChargeBack() {
      const vm = this;
      this.operationLogInputDto.workOrderId = this.workOrderId;

      this.$refs.form.validate(async (val) => {
        if (val) {
          vm.saving = true;
          abp.ajax.post('/api/services/app/WorkOrder/WorkOrderChargeback', vm.operationLogInputDto).then(() => {
            vm.cancel();
            vm.$emit('saveSuccess');
            vm.$emit('onRefreshOperationLog')
          }).finally(() => {
            vm.saving = false;
          });
        }
      });
    }
  },
  created() {
  }
};
